// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Terminations_wrapper__3bO29","wrapper__content":"Terminations_wrapper__content__1j_MM","wrapper__content__left":"Terminations_wrapper__content__left__T1Lhp"};